import React, {Fragment, useState} from 'react';
import {Box, Stack, useTheme} from '@mui/material';

import Icon from 'presentation/icons';
import {SectionContainer} from './styles';
import {QualificationsModal} from '../QualificationsModal';

import {QualificationListProps} from './types';
import {QUALIFICATIONS} from '../../../constants/qualifications';

export function QualificationList({qualifications, isInverse}: QualificationListProps) {
	const theme = useTheme();
	const [open, setOpen] = useState(false);

	function handleOpenQualificationModal() {
		setOpen(true);
	}

	return (
		<Fragment>
			<SectionContainer
				$isInverse={isInverse}
				onClick={handleOpenQualificationModal}
				sx={{cursor: 'pointer'}}>
				<Stack direction="row" gap={1}>
					{qualifications.map(qualification => {
						const qualificationDetails = QUALIFICATIONS.find(
							item => item.code === Number(qualification.cdTipoQualificacao),
						);

						if (!qualificationDetails) {
							return null;
						}

						return (
							<Box
								key={qualificationDetails.code}
								component="img"
								sx={{
									height: qualificationDetails?.height ?? 16,
									width: qualificationDetails?.width ?? 16,
								}}
								src={qualificationDetails.image}
								alt={qualificationDetails.label}
							/>
						);
					})}
				</Stack>
				<Icon name="info-outlined" color={theme.palette.primary.main} />
			</SectionContainer>

			<QualificationsModal open={open} setOpen={setOpen} />
		</Fragment>
	);
}
